export enum SearchMode {
    standard = 'standard',
    expert = 'expert'
}
